import positions from './positionManagementStore';
import positionConfiguration from './positionConfigStore';

export default {
  namespaced: true,
  modules: {
    positions,
    positionConfiguration,
  },
};